import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CartModalComponent,
         ErrorMessagesComponent,
         FacebookLoginComponent,
         SideMenuComponent } from './';

@NgModule({
  declarations: [
    CartModalComponent,
    ErrorMessagesComponent,
    FacebookLoginComponent,
    SideMenuComponent
  ],
  entryComponents: [
    CartModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    CartModalComponent,
    ErrorMessagesComponent,
    FacebookLoginComponent,
    SideMenuComponent
  ]
})
export class UtilsModule {}



// WEBPACK FOOTER //
// ./src/components/+utils/utils.module.ts